import React from "react";

const PlusSvg = () => {
  return (
    <svg
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.88035 7.87813C7.88035 5.66672 7.88036 3.51158 7.8815 1.35758C7.8815 1.2175 7.87461 1.07398 7.89758 0.937348C7.99518 0.370144 8.51305 -0.0317218 9.08373 0.00731651C9.63604 0.0452066 10.0862 0.497592 10.1264 1.0602C10.1344 1.16469 10.1298 1.27147 10.1298 1.37595C10.1298 3.4025 10.1298 5.4279 10.1298 7.45445C10.1298 7.58075 10.1298 7.7082 10.1298 7.87813C10.2779 7.87813 10.4031 7.87813 10.5271 7.87813C12.6238 7.87813 14.7194 7.87354 16.8161 7.88043C17.729 7.88272 18.2893 8.77716 17.8599 9.53955C17.6256 9.9552 17.2547 10.1309 16.7794 10.1297C14.7068 10.1251 12.6341 10.1274 10.5604 10.1274C10.4329 10.1274 10.3055 10.1274 10.1286 10.1274C10.1286 10.2698 10.1286 10.3927 10.1286 10.5167C10.1286 12.6247 10.1309 14.7328 10.1264 16.8409C10.1252 17.3863 9.81632 17.7973 9.32142 17.9489C8.86212 18.0901 8.34196 17.9328 8.09393 17.5091C7.96533 17.2898 7.89069 17.0062 7.88839 16.7502C7.87232 14.6892 7.87921 12.627 7.87921 10.566C7.87921 10.4374 7.87921 10.31 7.87921 10.1263C7.74256 10.1263 7.62085 10.1263 7.49798 10.1263C5.40126 10.1263 3.30569 10.1297 1.20897 10.1251C0.333999 10.1228 -0.233241 9.33403 0.0951606 8.57278C0.301847 8.09284 0.689959 7.87468 1.21242 7.87583C3.29651 7.87813 5.38174 7.87698 7.46583 7.87698C7.59214 7.87813 7.7173 7.87813 7.88035 7.87813Z"
        fill="white"
      />
    </svg>
  );
};

export default PlusSvg;
